import { render, staticRenderFns } from "./ProductionGeneral.vue?vue&type=template&id=04b8b7e7&scoped=true&"
import script from "./ProductionGeneral.vue?vue&type=script&lang=js&"
export * from "./ProductionGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProductionGeneral.vue?vue&type=style&index=0&id=04b8b7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8b7e7",
  null
  
)

export default component.exports